//src/components/CreatorHistoryTimeline.jsx

import { useEffect, useState } from "react";
import API from "../services/api";
import "./CreatorHistoryTimeline.css";

export default function CreatorHistoryTimeline({ creatorId }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const response = await API.get(`/creators/${creatorId}/history`);
        setHistory(response.data);
      } catch (err) {
        console.error("Failed to fetch history:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchHistory();
  }, [creatorId]);

  if (loading) return <p>Loading history...</p>;
  if (!history.length) return <p>No history available.</p>;

  return (
    <div className="history-timeline">
      <h3>📊 Creator History</h3>
      <ul>
        {history.map((snap, idx) => (
          <li key={idx} className="history-item">
            <div className="history-date">
              {new Date(snap.analyzed_at).toLocaleString()}
            </div>
            <div className="history-metrics">
              <p><strong>Followers:</strong> {snap.followers}</p>
              <p><strong>Avg Views:</strong> {snap.avg_views}</p>
              <p><strong>Avg Likes:</strong> {snap.avg_likes}</p>
              <p><strong>Avg Comments:</strong> {snap.avg_comments}</p>
              {snap.alpha_score && (
                <p><strong>Alpha Score:</strong> {snap.alpha_score}/100</p>
              )}
            </div>
            {snap.last_video_url && (
              <div className="history-video">
                <a href={snap.last_video_url} target="_blank" rel="noreferrer">
                  Last Analyzed Video
                </a>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
